import * as React from 'react'

import { ContentHelpCenter } from '~/organisms/content/ContentHelpCenter'
import { ContentEpisodeFaqRow } from '~/molecules/content/ContentEpisodeFaqRow'

import * as Style from './style.css'

export const ContentEpisodeFaqRows = (): JSX.Element => {
  return (
    <div className={Style.ContentEpisodeFaqRows}>
      <ContentEpisodeFaqRow
        question={'ベビーシッターや家事代行サポーターの時給は、いくらくらい？'}
        answer={
          <>
            ベビーシッターの時給目安は<b>首都圏で2,100円〜2,400円</b>、
            その他の地域は<b>1,600円〜2,000円</b>となりますが、
            2,500円以上でも予約が入るベビーシッターも多くいます。
            保育士や幼稚園教諭、看護師、産後ドゥーラなどの資格をお持ちの場合は時給を高く設定している方が多いです。
            未経験者であってもお人柄、育児経験や特技、お住まいの地域などから総合的にみて、
            たくさんの依頼を得るベビーシッターも多くいらっしゃいます。
            <br />
            <br />
            家事代行サポーターについても、時給目安は
            <b>首都圏で2,300〜2,600円</b>、 その他の地域は<b>2,000〜2,300円</b>
            となっています。
            整理収納アドバイザーの資格や調理師免許など、ご自身のスキルを活かしたり、
            長年の家事経験を評価されて、多くの定期依頼を受けている方もいらっしゃいます。
            <br />
            下記URLからご活動中のベビーシッターや家事代行サポーターの時給もご覧になれますので、ぜひご参考ください。
            <br />
            ▼キッズライン
            <br />
            <a href="https://kidsline.me/">https://kidsline.me/</a>
          </>
        }
      />
      <ContentEpisodeFaqRow
        question={
          'ベビーシッターや家事代行サポーターは、資格や経験がなくても大丈夫？'
        }
        answer={
          <>
            家事代行サポーターに関しては、選考に当たって資格の有無は問いません。
            他のご家庭でお掃除や料理、片付けなどをするお仕事に興味がある方は、ぜひ登録説明会に参加ください。
            <br />
            ベビーシッターに関しては選考にあたり、下記の資格証または修了証のご用意が必須となります。
            <br />
            ＜該当の資格証＞
            <br />
            ・保育士（旧姓・保母資格不可）
            <br />
            ・看護師（旧姓不可）
            <br />
            ・准看護師（旧姓不可）
            <br />
            ・全国保育サービス協会(ACSA)認定ベビーシッター
            <br />
            ＜該当の研修修了証＞
            <br />
            ・子育て支援員研修（地域保育コース）
            <br />
            ・家庭的保育者等研修
            <br />
            ・全国保育サービス協会(ACSA)ベビーシッター養成研修＋現任研修
            <br />
            ・全国保育サービス協会(ACSA)居宅訪問型基礎研修
            <br />
            <br />
          </>
        }
        answerNote={
          <>
            ※資格証・修了証に関しては、卒業証書や合格通知などは不可となります。また原本が必要となりますので予めご留意ください。
            <br />
            ※該当の研修修了証は旧姓のままで問題ございません。
            但し、ご本人の研修修了証であることがご確認できるよう、新旧姓併記の本人確認書類のご用意をお願いいたします。
            <br />
            ※産後ドゥーラやファミリーサポート会員など何かしらの資格をお持ちでも、上記以外の資格証・研修修了証でない限り該当になりませんので、予めご承知おきください。
            <br />※
            ベビーシッターについては現在男性のご登録受付は停止しております。再開時期は未定でございます。再開の際にはHPで告知致します。
          </>
        }
      />
      <ContentEpisodeFaqRow
        question={'他の仕事があってもキッズラインに登録できる？'}
        answer={
          <>
            <b>副業が認められているご職業でしたら、問題ございません。</b>
            キッズラインでは多くの現役保育士さんが副業でベビーシッターをされています。
            また、別のお仕事をしながら休日のみ家事代行サポーターを行っている方もいらっしゃいます。
            本業に加えてもう少し収入を増やしたいとお考えの方には、お勧めの副業です。
          </>
        }
      />
      <ContentEpisodeFaqRow
        question={'月に何回は働かなきゃいけないとかある？'}
        answer={
          <>
            キッズラインでは、ご自身で働きたいと思う日にちや時間を登録する形を取っております。
            そのため、
            <b>1ヶ月に何日働かなければいけないといったノルマはございません。</b>
            ご自身の別のお仕事や家事育児などのプライベートの時間を十分に確保しながら、働きたい時間にだけお仕事をすることが可能です。
            また雇用契約ではないため、基本的にはキッズラインから電話で業務指示をすることはございません。（※）
            <br />
            <br />
          </>
        }
        answerNote={
          <>
            ※東京都ベビーシッター利用支援事業の待機児童事業や福岡市産前産後ケア事業といった自治体委託のお仕事の場合はお電話することがございます。
          </>
        }
      />
      <ContentEpisodeFaqRow
        question={'個人事業主ってハードルが高そう……私にできる？'}
        answer={
          <>
            選考合格後は、ベビーシッター・家事サポーターともに活躍推進担当が、
            <b>デビューの際に伴走支援</b>をさせていただいております。
            プロフィールの書き方やキャンペーンの設定の仕方など、丁寧に対応していきますので、ご心配なくデビューすることができます。
            <br />
            またキッズラインでは、スキルアップがしたい方や初めて個人事業主としてお仕事をされる方に向けて、
            <b>オンライン講座「キッズライン大学」を無料で開講</b>しています。
            <br />
            「はじめての個人事業主講座」や「初めてのZoom講座」など、新米サポーターをフォローする体制を整えて、学びたい方をバックアップ。
            また、ベビーシッター向けには「子どもの急な体調不良」などの安全サポート研修、家事サポーター向けには「物損防止講座」もご用意。
            <b>スキルアップできる環境も整えています。</b>
          </>
        }
      />
      <ContentHelpCenter />
    </div>
  )
}
